<template>
  <div>
    <v-layout justify-center>
      <v-flex>
        <v-card ref="form">
          <v-toolbar color="primary" dark>
            <v-toolbar-title>
              <span v-if="!!id">Изменить шаблон</span>
              <span v-else> <div>Добавить шаблон</div></span>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-toolbar-items>
                <v-btn @click="closeDialog" class="pa-0 ma-0" dark flat icon>
                  <v-icon>close</v-icon>
                </v-btn>
              </v-toolbar-items>
            </v-toolbar-items>
          </v-toolbar>
          <v-card-text>

            <v-text-field
              :error="hasError('name')"
              :error-messages="getError('name')"
              label="Наименование"
              ref="number"
              required
              v-model="value.name"
            ></v-text-field>

            <v-autocomplete
              :error="hasError('field')"
              :error-messages="getError('field')"
              :items="selectors.file_fileds"
              label="Тип документа"
              v-model="value.field"
              no-data-text ="Нет данных"
            ></v-autocomplete>

            <FileInput
              v-bind:fieldLabel="'Документ'"
              v-bind:field="'document'"
              @updateFile="updateFile"
              v-bind:file=value.document
              v-bind:error="hasError('document')"
              v-bind:error_messages="getError('document')"
            ></FileInput>
            <v-alert
              :value="hasError('detail')"
              type="error"
            >
              {{getError('detail')}}
            </v-alert>
            <v-btn @click="apply" color="primary">Сохранить</v-btn>
          </v-card-text>
          <v-divider class="mt-5"></v-divider>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
    import urls from "../../../../../modules/petition/urls"
    import UserDataFormMixin from '../../../../../mixins/UserDataFormMixin'
    import {makeGetRequest, makePostRequestFile} from "../../../../../helper";
    import FileInput from "../../../../diss/components/FileInput"

    export default {
        name: "Language",
        mixins: [UserDataFormMixin],
        components: {FileInput},
        props: {
            id: Number,
            name: String,
            document: String,
            field:String,
        },
        data() {
            return {
                URL_CREATE: urls.getUrl('admin|core|models|document_template-list', 'create'),
                URL_UPDATE:  urls.getUrl('admin|core|models|document_template-detail', 'update'),
                selectors:{
                    file_fileds: [],
                },
                value: {
                    id: this.id || '',
                    name: '',
                    document:  null,
                    filed:  null,
                },
                // errors: {}
            }
        },
        watch: {
            $props: {
                handler() {
                    if(this.id){
                        let url =  this.URL_UPDATE.replace('<id>',this.value.id)
                        let sys = true
                        makeGetRequest(url).then(resp => {
                            if (!resp.ok) {
                                sys = false
                            }
                            return resp.json()
                        }) .then(json => {
                            this.value=json
                        })
                    }


                },
                deep: true,
                immediate: true,
            },
        },
        methods: {
            closeDialog() {
                this.$emit('ended', '')
            },
            updateFile(item) {
                this.value[item.field] = item.file;
            },
            apply: function () {

                let url = this.URL_CREATE;
                let method = 'POST'

                if (this.id !== undefined) {
                    method = 'PATCH'
                    url = this.URL_UPDATE.replace('<id>', this.id);
                }

                let data = Object.assign({}, this.value);

                var formData = new FormData();

                for (var key in data) {
                    if (data[key] !== undefined && data[key] !== null )
                        if(key === 'document'){
                            if(typeof data[key] !== 'string')
                              formData.append(key, data[key])
                        }else {
                            formData.append(key, data[key])
                        }
                }

                let status = true;
                makePostRequestFile(url, formData, method)
                    .then(resp => {
                        if (!resp.ok) {
                            status = false;
                        }
                        return resp.json()
                    })
                    .then(json => {

                        if (status) {
                            this.$emit('addItem', json);
                        } else {
                            this.receiveErrors(json);
                        }

                    })

            },
        },
        created() {
            let url = process.env.VUE_APP_API_HOST +"council/admin/core/selectors/file_fields/"
            let sys = true
            makeGetRequest(url).then(resp => {
                if (!resp.ok) {
                    sys = false
                }
                return resp.json()
            }) .then(json => {
                this.selectors.file_fileds = json
            })
        }
    }

</script>

<style scoped>

</style>
